<template>
  <div class="video">
    <div class="video-view">
      <!-- <div>
        <div class="video-title video-green-font">{{ title }}</div>
        <div class="video-sameline">
          <div class="video-light-green-font">老師：{{ teacher }}</div>
          <div class="video-light-green-font">上載日期：{{ date }}</div>
        </div>
        <hr class="video-green-font">
      </div> -->
      <div class="container-fluid" style="margin-bottom: 2rem">
        <div style="display: flex; width: 100%; visibility: visible;flex-wrap:wrap" id="kaltura_table">
          <div class="col66" style="background-color: rgb(239, 239, 239)">
            <div style="width: 100%;display: inline-block; position: relative;">
              <div style="margin-top: 56.25%"></div>
              <div id="video_div" class="kWidgetIframeContainer" style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: -56px; height: 100%; overflow: hidden;">
                <video id="video" style="width: 100%; height: 100%;" :src="file.main.html_path" controls @timeupdate="updateTime"></video>
              </div>
            </div>
            <div class="video-button-right" style="padding: 0.5rem 0">
              <eva-icon fill="#397f1f" :name="heartName" @click="like" />
              <eva-icon fill="#397f1f" :name="bookmarkName" style="margin-right:0.2rem;" @click="bookmark" />
            </div>
          </div>
          <div class="col33 " style="padding: 1rem 1rem 1rem 0.5rem">
            <div style="font-size: 20pt; line-height: 1; border-bottom: 1px solid black; margin-bottom: 0.5rem">
              <div style="padding-bottom: 0.5rem; color: #397f1f; font-weight: 600">筆記<i class="clickable material-icons" style="float: right;" @click="add_note">add_circle_outline</i></div>
            </div>
            <div class="noteContent" style="width: 100%; display: inline-block; position: relative; overflow-y: scroll; ">
              <div style="margin-top: calc( 112.5% - 20pt ); ">
                <div id="note_list" style="position: absolute; top: 0px; min-height: 100%; width: 100%;">
                  <div class="notes" v-for="(note, index) in notes" :key="note.id" :id="note.id" :class="index % 2 === 0 ? 'evenRow': 'oddRow'">
                    <div>
                      <a class="time_string" @click="video_jump(note.time)">{{note.time_string}}</a>
                      <i class="material-icons" style="float: right;" @click="delete_note(note);">delete</i>
                      <i class="material-icons" style="float: right;" @click="edit_note(note);">edit</i>
                    </div>
                    <div class="message" id="note.id">{{note.message}}</div>
                  </div>
                </div>
                <div id="take_note" style="position: absolute; top: 0px; width: 100%; padding: 0px 15px; height: 100%; display: none; font-size: 1.5rem;" note_id="">
                  <div style="color: #397f1f;display: flex; justify-content: space-between; margin: 1rem 0">
                    <div style="font-weight: 600">時間:</div>
                    <div id="new_note_time" time="">
                      <span id="hour_span">00</span>:<span id="minute_span">00</span>:<span id="second_span">00</span>
                    </div>
                  </div>
                  <div style="color: #397f1f;font-weight: 600">筆記內容:</div>
                  <textarea :rows="4" style="width: 100%; margin: 1rem 0" id="new_note_content"></textarea>
                  <div style="width: 50%; display: inline-block; float: left; text-align: center;">
                    <el-button @click="post_note">確定</el-button>
                  </div>
                  <div style="width: 50%; display: inline-block; float: left; text-align: center;">
                    <el-button style="" @click="cancel_add_note">取消</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.video{
    display: flex;
}
.video-view{
    flex: 8;
    margin-top: 2rem;
}

.video-comment-date{
  position: absolute;
  bottom: 0.2rem;
  right: 0.5rem;
}
.button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}
.video-button-right{
    float:right;
    margin-right: 1rem;
}

.col66{
  flex: 2;
  @media (max-width: 800px) {
    flex: 0 0 100%
  }
  @media (min-width: 801px) {
    border-bottom-left-radius:2rem;
  }
}

.col33{
  flex: 1;
  background-color: rgb(239, 239, 239);
  border-top-right-radius:2rem;
  border-bottom-right-radius:2rem;
  @media (max-width: 800px) {
    flex: 0 0 100%;
    border-top-left-radius:0rem;
    border-top-right-radius:0rem;
    border-bottom-left-radius:2rem;
    .noteContent{
      max-height: 250px;
    }
  }
}
.evenRow{
  background: #fcfcfc;
}
.oddRow{

}
</style>
<script>
import { EvaIcon } from 'vue-eva-icons'
import $ from 'jquery'

export default {
  components: {
    [EvaIcon.name]: EvaIcon
  },
  data () {
    return {
      fId: this.$route.query.subject,
      vId: this.$route.query.file,
      file: {},
      notes: []
    }
  },
  computed: {
    heartName: function () {
      return this.file.is_like ? 'heart' : 'heart-outline'
    },
    bookmarkName: function () {
      return this.file.is_bookmarked ? 'bookmark' : 'bookmark-outline'
    }
  },
  methods: {
    get_video_info: async function () {
      let result = await this.$store.dispatch('request', {
        route: `resources/folders/${this.fId}/items/${this.vId}`
      })
      this.file = result
      console.log(this.file)
      console.log(result.entry_id)
      return result.entry_id
    },
    like: async function () {
      console.log('like')
      let route = ''
      if (!this.file.is_like) {
        route = `resources/folders/${this.fId}/items/${this.vId}/like`
      } else {
        route = `resources/folders/${this.fId}/items/${this.vId}/unlike`
      }
      console.log(route)
      try {
        let result = await this.$store.dispatch('request', {
          method: 'post',
          route: route
        })
        console.log(result)
        this.file.total_likes += this.file.is_like ? -1 : 1
        this.file.is_like = !this.file.is_like
        console.log(this.file)
      } catch (err) {
        console.log(err)
      }
    },
    bookmark: async function () {
      console.log('bookmark')
      let route = ''
      if (!this.file.is_bookmarked) {
        route = `resources/folders/${this.fId}/items/${this.vId}/bookmark`
      } else {
        route = `resources/folders/${this.fId}/items/${this.vId}/unbookmark`
      }
      console.log(route)
      try {
        let result = await this.$store.dispatch('request', {
          method: 'post',
          route: route
        })
        console.log(result)
        this.file.is_bookmarked = !this.file.is_bookmarked
        console.log(this.file.is_bookmarked)
        console.log(this.file)
      } catch (err) {
        console.log(err)
      }
    },
    get_notes: async function () {
      this.$store.dispatch('request', {
        method: 'get',
        route: `resources/folders/${this.fId}/items/${this.vId}/notes`
      }).then(r => {
        console.log(r)
        r.forEach(value => {
          console.log(value)
          let hour = parseInt(value.time / 3600)
          if (hour < 10) {
            hour = '0' + hour
          }
          let minute = ('00' + parseInt(value.time % 3600 / 60)).substr(-2)
          let second = ('00' + parseInt(value.time % 60)).substr(-2)
          let timeString = `${hour}:${minute}:${second}`
          this.notes.push({
            id: value.id,
            time: value.time,
            message: value.message,
            time_string: timeString
          })
        })
      })
    },
    add_note: function () {
      $('#take_note').show()
      $('#note_list').hide()
      $('#take_note').attr('note_id', '')
      $('#new_note_content').val('')
    },
    cancel_add_note: function () {
      $('#take_note').hide()
      $('#note_list').show()
    },
    post_note: async function () {
      let noteId = $('#take_note').attr('note_id')
      console.log(noteId)
      let route = `resources/folders/${this.fId}/items/${this.vId}/notes`
      let fd = new FormData()
      let message = $('#new_note_content').val()
      let timeString = $('#new_note_time').text()
      let time = $('#new_note_time').attr('time')
      if (noteId !== undefined && noteId.length > 0) {
        route = route + '/' + noteId
        fd.append('note_id', noteId)
      }
      fd.append('message', message)
      fd.append('time_string', timeString)
      fd.append('time', time)
      console.log(route)
      try {
        let result = await this.$store.dispatch('request', {
          method: 'post',
          route: route,
          data: fd
        })
        console.log(result)
        if (noteId !== undefined && noteId.length > 0) {
          $(`#${noteId} .message`).text(message)
          console.log(noteId)
          console.log(message)
        } else {
          this.$store.dispatch('request', {
            method: 'get',
            route: `resources/folders/${this.fId}/items/${this.vId}/notes`
          }).then(r => {
            this.notes.push({
              id: r[r.length - 1].id,
              time: time,
              message: message,
              time_string: timeString
            })
          })
        }
        $('#take_note').hide()
        $('#note_list').show()
      } catch (err) {
        console.log(err)
      }
    },
    edit_note: async function (note) {
      $('#take_note').attr('note_id', note.id)
      $('#new_note_time').attr('time', note.time)
      let timeObj = note.time_string.match(/([0-9]+):([0-9]+):([0-9]+)/)
      $('#new_note_time #hour_span').text(timeObj[1])
      $('#new_note_time #minute_span').text(timeObj[2])
      $('#new_note_time #second_span').text(timeObj[3])
      console.log($(`#${note.id} .message`).text())
      $('#new_note_content').val($(`#${note.id} .message`).text())
      $('#take_note').show()
      $('#note_list').hide()
      console.log(timeObj)
    },
    delete_note: async function (note) {
      let route = `resources/folders/${this.fId}/items/${this.vId}/notes/${note.id}`
      console.log(route)
      this.$store.dispatch('request', {
        method: 'delete',
        route: `resources/folders/${this.fId}/items/${this.vId}/notes/${note.id}`
      }).then(r => {
        console.log(r)
      })
      let index = this.notes.findIndex(n => n.id === note.id)
      this.notes.splice(index, 1)
    },
    video_jump: function (time) {
      console.log(time)
      document.getElementById('video').currentTime = time
      // let kdp = document.getElementById('video_div')
      // kdp.sendNotification('doSeek', time)
    },
    updateTime: function (e) {
      console.log(e.target.currentTime)
      let currentTime = e.target.currentTime
      let hour = parseInt(currentTime / 3600)
      if (hour < 10) {
        hour = '0' + hour
      }
      $('#hour_span').text(hour)
      $('#minute_span').text(('00' + parseInt(currentTime % 3600 / 60)).substr(-2))
      $('#second_span').text(('00' + parseInt(currentTime % 60)).substr(-2))
      $('#new_note_time').attr('time', currentTime)
    }
  },
  mounted () {
    this.get_video_info().then(r => {
      console.log(r)
      // let script = document.createElement('script')
      // script.setAttribute('src', 'http://streaming.ureply.mobi/html5/html5lib/v2.76/mwEmbedLoader.php')
      // script.onload = function () {
      //   window.kWidget.embed('video_div', {
      //     wid: '_101',
      //     uiconf_id: 23448173,
      //     entry_id: r,
      //     readyCallback: function (id) {
      //       console.log(id)
      //       let kdp = document.getElementById(id)
      //       kdp.kBind('monitorEvent', function () {
      //         let currentTime = kdp.evaluate('{video.player.currentTime}')
      //         console.log('video.player.currentTime: ' + currentTime)
      //         let hour = parseInt(currentTime / 3600)
      //         if (hour < 10) {
      //           hour = '0' + hour
      //         }
      //         $('#hour_span').text(hour)
      //         $('#minute_span').text(('00' + parseInt(currentTime % 3600 / 60)).substr(-2))
      //         $('#second_span').text(('00' + parseInt(currentTime % 60)).substr(-2))
      //         $('#new_note_time').attr('time', currentTime)
      //       })
      //       kdp.kBind('mediaReady', function () {
      //         $('#kaltura_table').css('visibility', 'visible')
      //       })
      //     }
      //   })
      // }
      // document.head.appendChild(script)
    })
    this.get_notes()
  }
}
</script>
